import { EMFieldCombineType, EMFieldLevel, IMField, IMFieldColumn, IMFieldLevelToColor, IMFieldList } from './typings';

export const MFieldLevelOptions = [
  {
    label: '第一级',
    value: 'level1'
  },
  {
    label: '第二级',
    value: 'level2'
  },
  {
    label: '第三级',
    value: 'level3'
  }
];

export class MField {
  checked: boolean;
  uuid: string; // 唯一标识
  name: string; // 名称
  color: string; // 颜色
  combineName: string; // 组合名称
  combineType: EMFieldCombineType; // 组合类型
  level: EMFieldLevel;
  description: string;
  source: IMField;

  constructor(source: IMField) {
    this.source = source;
    this.uuid = source.uuid;
    this.checked = false;
    this.name = source.name;
    this.color = source.color ?? '#0000ff';
    this.combineType = source.combineType ?? EMFieldCombineType.char;
    this.combineName = source.combineName ?? '字段';
    this.level = source.level ?? EMFieldLevel.level3;
    this.description = source.description ?? '';
  }
}

export class MFieldColumn {
  name: string;
  key: string;
  visible: boolean;

  constructor(column: IMFieldColumn) {
    this.name = column.name;
    this.key = column.key;
    this.visible = true;
  }
}

export class MFieldsDataSource {
  data: MField[] = [];
  searchParams = { name: '' };

  get displayData(): MField[] {
    return this.data.filter(e => e.name.includes(this.searchParams.name));
  }

  constructor(source: IMFieldList) {
    this.data = source.map(s => new MField(s));
  }

  deleteItems(items: MField[]): void {
    const _data = [...this.data];
    items.forEach(item => {
      const _index = _data.findIndex(e => e.uuid === item.uuid);
      _data.splice(_index, 1);
    });
    this.data = _data;
  }

  addItems(items: IMField[]): void {
    this.data = [...this.data, ...items.map(e => new MField(e))];
  }

  search(params: { name: string }): void {
    const { name } = params;
    this.searchParams.name = name;
  }

  updateColorByLevel(item: MField, levelToColor: IMFieldLevelToColor): void {
    const _data = [...this.data];
    const _index = _data.findIndex(e => e.uuid === item.uuid);
    _data[_index].color = levelToColor[item.level];
  }
}
